import { combineReducers } from "redux";

import { alertReducer } from "./alert.reducer";
import { authenticationReducer } from "./authentication.reducer";
import { reportsReducer } from "./reports.reducer";
import { identitiesReducer } from "./identities.reducer";

import { IAuthenticationState } from "../contracts/IAuthenticationState";
import { IReportEntries } from "../contracts/IReportEntries";
import { IIdentityEntries } from 'src/contracts/IIdentityEntries';
import { IResetPasswordState } from 'src/contracts/IResetPasswordState';
import { resetPasswordReducer } from './reset_password.reducer';

export interface IRootState {
  authState: IAuthenticationState;
  resetPasswordState: IResetPasswordState;
  alert: string;
  reports: IReportEntries;
  identities: IIdentityEntries;
}

const rootState = combineReducers<IRootState>({
  alert: alertReducer,
  authState: authenticationReducer,
  identities: identitiesReducer,
  reports: reportsReducer,
  resetPasswordState: resetPasswordReducer
} as any);

export default rootState;



// WEBPACK FOOTER //
// ./src/reducers/index.ts